<template>
    <div class="partners-wrapper">
        <!-- PARTNERS FILTER START -->

        <div class="partners_box">
            <partners-filter/>
        </div>
        <!-- PARTNERS FILTER END -->

        <!-- PARTNERS LIST START -->
        <div class="partners">
            <partners-list/>
        </div>
        <!-- PARTNERS LIST END -->

        <modal
            :show="show"
            @close="toggleModal"
            :outside="false"
            :dark="false"
        >
            <partners-add-modal
                v-if="show"
            />
        </modal>

        <modal
            :show="showDeleteModal"
            :showBtn="false"
            :outside="false"
            :dark="false"
            @close="toggleDeleteModal"
        >
            <delete-modal
                :title="$t('global.areUsure')"
                :cancelDeletionTag="deletionStatus && !$guard('write', 'Partners')"
                @cancel="toggleDeleteModal"
                @next="removeAction"
            />
        </modal>
        <div
            v-if="$guard('write', 'Partners')"
            class="partners__add"
        >
            <div class="partners__add-text">{{$t('partners.add')}}</div>
            <div class="partners__add-button" @click="toggleModal"></div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import partnersList from '@/components/lists/partners/partnersList'
import partnersFilter from '@/components/filters/partners/partnersFilter'
import partnersAddModal from '@/components/modals/partners/partnersAddModal'

export default {
    name: 'partners',
    components: {
        partnersList,
        partnersFilter,
        partnersAddModal,
    },
    computed: {
        ...mapGetters({
            show: 'partners/addModal',
            showDeleteModal: 'partners/deleteModal',
            deletionStatus: 'partners/deletionStatusGetters',
            partnerDeleteId: 'partners/partnerDeleteId',
        }),
    },
    methods: {
        ...mapMutations({
            toggleModal: 'partners/setAddModal',
            toggleDeleteModal: 'partners/setDeleteModal',
        }),
        ...mapActions({
            remove: 'partners/remove',
            requestForDelete: 'deleteControl/requestForDelete',
            fetch: 'partners/fetch',
        }),
        async removeAction() {
            if (!this.$guard('delete', 'Partners')) {
                await this.requestForDelete({
                    id: this.partnerDeleteId,
                    type: 'partners',
                })

                await this.fetch({})
                this.$emit('close')
                return
            }

            this.remove()
        },
    },
    created() {
        this.fetch({})
    },
}
</script>

<style lang="scss" scoped>
    .partners-wrapper {
        margin: 40px 60px 35px;
        width: 100%;
        overflow: hidden;

        h2 {
            margin: 40px 0 15px;

        }
    }

    .partners_box {
        width: calc(100% - 120px) !important;
    }

    .partners {
        border-radius: 8px;
        height: auto;
        position: relative;
        overflow: hidden;
        width: calc(100% - 130px) !important;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16) !important;

        &__add {
            position: fixed;
            right: 25px;
            bottom: 25px;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: end;
            -ms-flex-align: end;
            align-items: flex-end;
        }

        &__add-button {
            width: 56px;
            height: 56px;
            border-radius: 50%;
            background-color: #71bd4a;
            -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
            background-image: url(/images/icon/add.svg) !important;
            background-position: center;
            background-size: 20px;
            background-repeat: no-repeat;
            -webkit-transition: 0.5s;
            transition: 0.5s;
            cursor: pointer;
        }

        &__add-text {
            color: #4d4d4d;
            font-size: 12px;
            margin-right: 16px;
            font-family: "SFUIDisplay-Medium";
        }

    }
</style>
